// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SESSION_ID } from '../../../../config/session-id';
import { ua } from '../../../../util/user-agent';
import { Captcha } from '../../../components/captcha/captcha.model';

/** @ngInject */
export function Controller(
    $http,
    $rootScope,
    $scope,
    $state,
    $timeout,
    AuthenticationSharedService,
    BarcodeGeneratonService,
) {
        const vm = $scope.vm = {};
        $scope.username = localStorage.getItem('username');
        $scope.rememberMe = !!$scope.username;
        let sendingPushLoginNotification = false;
        const captcha = $scope.captcha = new Captcha();
        if(AuthenticationSharedService.getGmpLoginSession()){
            $state.go('gmp-config');
        } else if ($rootScope.account) {
            $state.go('user');
        }

    const $ctrl = this;

    $ctrl.loadQrData = () => {
        return BarcodeGeneratonService
            .get({uuid: SESSION_ID}).$promise
            .then((barcode) => {
                $rootScope.passwordMode = $ctrl.passwordMode = barcode.passwordMode;
                $ctrl.mobileLoginUrl = `${window.env.urlSchemaWa}://login?barcode=${barcode.bluetoothcode}`;
                if (!$state.params.domain) {
                    $ctrl.bluetoothCode = barcode.bluetoothcode;
                }
                return barcode.barcodeimage;
            });
    };
               
        // Saaspass Connect login request check
        $rootScope.isSaaspassConnectLogin = false;
        var clientDisplayName = $state.params.client;
        if(clientDisplayName){
            $rootScope.isSaaspassConnectLogin = true;
            $scope.clientDisplayName = clientDisplayName;
        }

        if ($scope.rememberMe && captcha.isValid()) {
            // send push login only if not authenticated
            if (!localStorage.getItem('token')) {
                pushLogin($scope.username);
            } else {
                $http
                    .get('app/rest/account', {ignoreAuthModule: true})
                    .catch(() => pushLogin($scope.username));
            }
        }
        
    $scope.$on('websocket.LOGIN', (event, data) => {
        const {username, password} = data;
        AuthenticationSharedService.login({username, password});
    });

        function onPushLoginSuccess(username) {
            vm.pushLoginPopoverIsOpen = true;
            $timeout(2000).then(() => vm.pushLoginPopoverIsOpen = false);
            if ($scope.rememberMe) {
                localStorage.setItem('username', $scope.username);
            }
        }
        
        $scope.pushLogin = pushLogin;
        function pushLogin(username) {
            if(!username){
                username = $scope.username;
            }

            sendingPushLoginNotification = true;
            AuthenticationSharedService
                .sendPushLoginNotification(captcha.response, username)
                .then(onPushLoginSuccess)
                .finally(() => {
                    captcha.reset();
                    sendingPushLoginNotification = false;
                });
        }
        
        $scope.pulssing = "";
        
        $scope.pulse = function() {            
                $scope.pulssing = "pulseAnimate";
                $("html, body").animate({ scrollTop: $(document).height() }, 2000);

                $timeout(function() {
                    $scope.pulssing = "";
                }, 2000);
        };

        $scope.login = function () {
            AuthenticationSharedService.login({
                username: $scope.username,
                password: $scope.password,
                captchaResponse: captcha.response
            })
            .then(() => $scope.rememberMe && localStorage.setItem('username', $scope.username))
            .finally(() => captcha.reset());
        };
        
        $scope.rememberMeChanged = function () {
            if (!$scope.rememberMe) {
                localStorage.removeItem('username');
            }
        };
        
        $scope.newLoginButton = ua.isAndroid() || ua.isIOS();
       
        $scope.pushLoginDisabled = pushLoginDisabled;

        function pushLoginDisabled() {
            return !$scope.username
                || sendingPushLoginNotification
                || vm.pushLoginPopoverIsOpen
                || !captcha.isValid();
        }
        
        if($state.params.domain){
            var code = $state.params.code;
            $scope.username = $state.params.domain;
            AuthenticationSharedService.login({
                username: `@${$state.params.domain}`,
                password: null,
                captchaResponse: captcha.response,
                googleAppsLogin : true,
                code:code
            }).finally(() => captcha.reset());
        }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/login/login.controller.js